export default __webpack_public_path__ + "static/media/screen6.1aab4308.png";